
function Tag({ tag, onClick, rounded }) {
  if (!tag || !tag.label) return null;

  const IconComponent = tag.icon;

  return (
    <div
      onClick={onClick ? onClick : () => console.log('Forbidden')}
      className={`py-1 px-3 ${rounded ? 'rounded-full' : 'rounded'
        } flex flex-row items-center gap-x-2 text-sm font-semibold w-fit overflow-hidden h-fit  ${tag.bgColor || 'bg-slate-600'
        } ${onClick ? 'cursor-pointer' : ''} text-slate-50 max-w-full`}>
      {IconComponent && (
        <IconComponent
          // className={styles.tagIcon}
          size={16}
          strokeWidth={2.5}
        />
      )}
      <p className="whitespace-nowrap text-ellipsis overflow-hidden"> {tag.label}</p>
    </div>
  );
}

export default Tag;
